export default "__VITE_ASSET__BcpQkYjO__"